module.exports = __webpack_public_path__ + "static/media/1.78cc6d9e.svg";